module.exports = __webpack_public_path__ + "static/media/santander.05b52435.svg";